export default __webpack_public_path__ + "static/media/7_2.95e5ec1b.png";